import { DownloadOutlined } from '@ant-design/icons';
import { Button, message, Tabs } from 'antd';
import leftline from 'assets/icons/arrow-left-line.png';
import { PageLoader } from 'components/page-loader/page-loader';
import { getCouponReportDownload } from 'features/events';
import { useGetEventDetailsData } from 'features/events/use-cases/get-event-details';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EventDetailsTopbar from '../event-details/event-details-topbar';
import { CouponTab } from '../event-details/show-hide-attributes/coupon/coupon-tab';

const EventDetailsTabs = () => {
  const [tabs, setTabs] = useState<any>("1")
  const [show, setShow] = useState<boolean>(false)
  const [exportLoading, setExportLoading] = useState<boolean>(false);
  const { id } = useParams();
  const { data, refetch } = useGetEventDetailsData(id);

  const handleTabChange = (activeKey: any) => {
    setTabs(activeKey);
  };


  useEffect(() => {
    if (tabs === "1") {
      refetch();
    }
  }, [tabs]);

  const handleExportCoupon = async () => {
    if (!id) return;
    try {
      setExportLoading(true);
      await getCouponReportDownload(id);
      message.success('Coupon report downloaded successfully');
    } catch (error) {
      console.error(error);
      message.error('Failed to download coupon report');
    } finally {
      setExportLoading(false);
    }
  };

  if (!id) return null;

  if (!data) return <PageLoader />;

  const items = [
    // {
    //   key: "1",
    //   label: "Event Details",
    //   children: <BasicContent id={id} data={data} refetch={refetch} />,
    //   className: 'cltb'

    // },
    // {
    //   key: "2",
    //   label: "Gallery",
    //   children: <GalleryComponent />,
    //   className: 'cltb'

    // },
    // {
    //   key: "3",
    //   label: "Tickets",
    //   children: <EventDetailsPriceCategory id={id} />,
    //   className: 'cltb'

    // },
    {
      key: "1",
      label: "Coupon",
      children: <CouponTab id={id} tab={tabs} />,
    },
    // {
    //   key: "5",
    //   label: "Attributes",
    //   children: <ShowHideAttributes />,
    //   className: 'cltb'
      
    // },
  ];

  return (
    <>
      <EventDetailsTopbar
        name={data.EventName}
        renderButtons={
          // Coupon is the only tab here, so its key is "1" (it is "5" in the admin panel).
          tabs === "1" ? (
            <Button
              icon={<DownloadOutlined />}
              onClick={handleExportCoupon}
              loading={exportLoading}
              style={{ backgroundColor: 'rgb(0, 0, 0)', color: '#ffffff', borderColor: 'rgb(0, 0, 0)' }}
            >
              Coupon Report
            </Button>
          ) : undefined
        }
      />

      <div className='sctnbx'>
        <div className={`row_wrap ${show ? "visible" : "hide"}`}>
          <div className='col'>

            <Tabs className="sctabbx" activeKey={tabs} onChange={handleTabChange} items={items} />

            <div className='ar_icon'>
              {show && <button type='button' className='btn' onClick={() => setShow(!show)}>
                <img className='' src={leftline} />
              </button>}
            </div>
          </div>

          {/* <div className='edbx_clm col'>
            <div className='bgcard evt_set' >
              <EventDetailsSetting id={id} setShow={setShow} show={show} />
            </div>
          </div> */}
        </div>


      </div>
    </>
  );
};

export default EventDetailsTabs;
